import { getAuthorizeCodes } from "utils/data-fetching/getAuthorizeCodes";
import { loginUserAuthorize } from "utils/data-fetching/loginUserAuthorize";
import { loginUser } from "utils/data-fetching/loginUser";
import IToken from "interfaces/token";
import getLoginFormError from "../getLoginFormError";
import { API_CONSTS, LOGIN_ERRORS } from "../../../../constants";

// Helper function for form submission
const handleLoginSubmit = async ({
  email,
  password,
  applicationId,
  urlSearchParams,
  saveToken,
  saveCode,
  setFormError,
}: {
  email: string;
  password: string;
  applicationId: string | null | undefined;
  urlSearchParams: URLSearchParams;
  saveToken: (token: IToken) => void;
  saveCode: (code: string) => void;
  setFormError: (error: string | null) => void;
}) => {
  const hasAuthorizeParam = urlSearchParams.has("authorize");
  const noParams = Array.from(urlSearchParams).length === 0;

  if (hasAuthorizeParam || noParams) {
    const loginUserAuthorizeResponse =
      applicationId &&
      (await loginUserAuthorize({ username: email, password, applicationId }));

    if (
      loginUserAuthorizeResponse ===
      API_CONSTS.RETRIEVE_AUTHORIZATION_CODE_RESPONSE
    ) {
      const authorizeResponse =
        applicationId && (await getAuthorizeCodes(applicationId));
      if (!authorizeResponse?.code) {
        setFormError(LOGIN_ERRORS.DEFAULT.userErrorMessage);
      } else {
        saveCode(authorizeResponse.code);
      }
    } else {
      const formError = getLoginFormError(
        loginUserAuthorizeResponse?.errorResponse ?? ""
      );
      setFormError(formError);
    }
  } else {
    const loginResponse =
      applicationId &&
      (await loginUser({ username: email, password, applicationId }));

    if (loginResponse?.tokens?.accessToken) {
      saveToken(loginResponse as IToken);
    } else {
      const formError = getLoginFormError(loginResponse?.errorResponse ?? "");
      setFormError(formError);
    }
  }
};

export default handleLoginSubmit;
